<script lang="ts">
  import InvoiceBreadcrumb from "@retailer/svelte/Payments/InvoiceBreadcrumb.svelte";
  import Invoice from "@retailer/svelte/Payments/Invoice.svelte";
  import { InvoiceStore } from "@retailer/stores/InvoiceStore";

  let paymentsEnabled = window["$rootScope"].user.term_payments;
  if (!paymentsEnabled) window.location.href = "/";

  let previousParams = window["$rootScope"].previousParams;

  export let invoiceId: number;
  $: heading = $InvoiceStore.invoice
    ? $InvoiceStore.invoice.distributor.name + " #" + $InvoiceStore.invoice.invoice_reference_id
    : "";

</script>

{#if paymentsEnabled}
  <div class="fizz-styles">
    <div class="fizz-layout-primary">
      <InvoiceBreadcrumb {heading} backLink={"layout.invoices"} backLinkParams={previousParams} />
      <Invoice {invoiceId} />
    </div>
  </div>
{/if}
